import { useEffect, useState } from "react";
import { RocketLaunch, Archive } from "@phosphor-icons/react";
import { act, api } from "@/lib/api";
import { Panel } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const CleanStart = ({ onDone }) => {
  const [st, setSt] = useState(null);
  const [open, setOpen] = useState(false);
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  useEffect(() => { api.get("/admin/clean-start").then((r) => setSt(r.data)).catch(() => setSt(null)); }, [res]);
  if (!st?.available || (st.launched && !res)) return null;
  const live = st.env === "live";
  const go = async () => {
    setBusy(true);
    const r = await act(() => api.post("/admin/clean-start", { confirm: word }), "MaSa is live - emails are going out now");
    setBusy(false);
    if (r) { setRes(r); setOpen(false); onDone?.(); }
  };
  if (res) return (
    <Panel title="Live with real clients" data-testid="clean-start-done">
      <p className="text-sm text-zinc-300">{res.launch.enrolled} contacts enrolled. Email 1 is sending now (about 30 a minute), follow-ups go out on day 3 and day 7. Social posts publish on the connected networks, and the newsletter is scheduled for {new Date(res.launch.newsletter_at).toLocaleString("en-AU")}.</p>
    </Panel>
  );
  return (
    <Panel title="Go live with real clients" data-testid="clean-start-panel">
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1 text-sm text-zinc-300 space-y-1">
          <div><b className="text-white">{st.name}</b> · {st.contacts.toLocaleString()} contacts</div>
          <div className="text-zinc-500 text-xs flex items-center gap-1.5"><Archive size={14} />
            {st.installed ? "This is the only campaign kept." : "This campaign will be installed."} Everything else ({st.other_launches} other launches, {st.other_campaigns} other campaigns, old test emails and drafts) is archived out of sight.
          </div>
          {!live && <div className="text-xs text-amber-400" data-testid="clean-start-preview-note">Real sending only runs on the live app (masa.platform.specia.ai). Press this button there.</div>}
        </div>
        <Button data-testid="clean-start-open-btn" disabled={!live} onClick={() => setOpen(true)} className="gap-2 bg-gradient-to-r from-[#6D28D9] via-[#C026D3] to-[#F97316] hover:opacity-90 text-white">
          <RocketLaunch weight="bold" /> Clean start &amp; go live
        </Button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="clean-start-dialog">
          <DialogHeader>
            <DialogTitle>Send to {st.contacts.toLocaleString()} real contacts?</DialogTitle>
            <DialogDescription>Old data is archived, real sending is switched on, the 3-email sequence starts now, and the social posts publish. Type GO LIVE to confirm.</DialogDescription>
          </DialogHeader>
          <Input data-testid="clean-start-confirm-input" value={word} onChange={(e) => setWord(e.target.value)} placeholder="GO LIVE" className="bg-black" />
          <DialogFooter>
            <Button variant="secondary" data-testid="clean-start-cancel-btn" onClick={() => setOpen(false)}>Cancel</Button>
            <Button data-testid="clean-start-confirm-btn" disabled={word !== "GO LIVE" || busy} onClick={go}>{busy ? "Going live…" : "Go live"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Panel>
  );
};
